import { Link } from 'react-router-dom';
import styles from './styles.module.css';

export const Header = () => {
    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <div className={styles.title}>Art Institute of Chicago</div>
                <div className={styles.navbar}>
                    <Link to="/" className={styles.link}>Home</Link>
                    <Link to="/" className={styles.link}>About</Link>
                    <Link to="/" className={styles.link}>Collection</Link>
                </div>
            </div>
        </header>
    )
}